import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {
    contasContabeisModuleName, modelosContaContabil,
    contaContabilCodigoMask, contasContabeisStorage, contasContabeisQuery
} from "../shared/data.service";
import { ContaContabil } from "../shared/conta-contabil.model";
import { ContaContabilCodigoValidator } from "../shared/validators/contaContabilCodigo.validator";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { ContaContabilService } from "../shared/conta-contabil.service";
import { ContaContabilApiService } from "../shared/conta-contabil-api.service";
import { ContaContabilNavigationService } from "../shared/conta-contabil-navigation.service";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { ContaContabilTipoApiService } from "../conta-contabil-tipos/shared/conta-contabil-tipo-api.service";

@Component({
    template: require('./conta-contabil-form.component.html')
})

export class ContaContabilFormComponent implements OnInit {
    contaContabilModule: string = contasContabeisModuleName;
    formObject: any = new ContaContabil();
    contaContabilPaiObject: any = new ContaContabil();
    actionTitle: string;
    btnSalveDisabled: boolean = false;
    submitted:boolean = false;
    loading: boolean = false;

    form:FormGroup;
    descricao = new FormControl('', Validators.required);
    tipo = new FormControl();
    descricaoAnalitica = new FormControl();
    codigo = new FormControl('', Validators.compose([Validators.required, ContaContabilCodigoValidator.contaContabilCodigoFormat]));
    pai = new FormControl();
    ativo = new FormControl();

    contaContabilSelectId: string = 'contacontabil_contaContabil';
    contaContabilQuery: any;
    codeExists: boolean = false;
    disabledModel: boolean = false;
    types: Array<any> = [];
    models: Array<any> = modelosContaContabil;
    codigoMask: number = contaContabilCodigoMask;

    private returnToOtherForm: boolean = false;
    private otherForm: string = "";
    private responseContaContabil: any;

    constructor(
        private _route: ActivatedRoute,
        private _contaContabilService:ContaContabilService,
        private _contaContabilApiService:ContaContabilApiService,
        private _contaContabilNavigationService:ContaContabilNavigationService,
        private _autocompleteService:AutoCompleteService,
        private _contaContabilTipoService: ContaContabilTipoApiService,
        private _utilService:UtilService,

        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            descricao: this.descricao,
            tipo: this.tipo,
            descricaoAnalitica: this.descricaoAnalitica,
            codigo: this.codigo,
            pai: this.pai
        });
    }

    ngOnInit() {
        this.getTiposContaContabil();
        this.isNewAutoComplete();

        this.contaContabilQuery = this._utilService.cloneObject(contasContabeisQuery);
        this.contaContabilQuery.where.descricaoAnalitica =  false;
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickCheckType(selectedItemKey: any) {
        this.formObject.tipoId = selectedItemKey;
        this.checkType();
    }

    clickCheckModel(selectedItemKey: any) {
        this.formObject.descricaoAnalitica = (selectedItemKey === 2) ? true : false;
        this.checkModel();
    }

    blurCode() {
        if (this.formObject.codigo) {
            this.checkIfExistsCode(this.formObject.codigo);
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if (evt.valid && !this.codeExists) {
            this.btnSalveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (!object.descricaoAnalitica) {
                object.tipoId = null;
                object.descricaoAnalitica = false;
            }

            if (this.contaContabilPaiObject.id) {
                object.paiId = this.contaContabilPaiObject.id;
            } else {
                object.paiId = null;
            }

            delete object['contas'];

            if (object.id) {
                this.onEditContaContabil(object);
            } else {
                this.onSaveContaContabil(object);
            }
        }
    }

    onGetContaContabilObject(object: any) {
        if (object.novo) {
            this.contaContabilPaiObject = {};
            this.formObject.codigo = '';
            return false;
        }

        this.contaContabilPaiObject = object;
        if (object.id) {
            this._utilService.setSelectOnFormControl(this.form, 'pai', object);
            this.onGetFather(object.id);
        } else {
            this._utilService.setSelectOnFormControl(this.form, 'pai', {id: -1});
        }
    }

    contaContabilTemplateResult = (function(state: any) {
        var template: any = this._contaContabilService.templateResult(state, false);
        return template;
    }.bind(this));

    private checkType() {
        if (this.formObject.tipoId) {
            var selectedItemKey:number = this.formObject.tipoId;

            setTimeout(function () {
                var tt:any = document.getElementById("type_" + selectedItemKey);
                if (tt) {
                    tt.checked = true;
                }
            });
        }
    }

    private checkModel() {
        var selectedItemKey: string;
        if (this.formObject.descricaoAnalitica) {
            selectedItemKey = this.models[1].Key;//analitica

            if (!this.formObject.tipoId) {
                this.formObject.tipoId = this.types[0].id;
            }
            this.checkType();
        } else {
            selectedItemKey = this.models[0].Key;//sintetica
        }

        setTimeout(function() {
            var tt: any = document.getElementById("model_"+selectedItemKey);
            if (tt) {
                tt.checked = true;
            }
        });
    }

    private onSaveContaContabil(objeto: any) {
        this._contaContabilApiService.onPost(objeto, this.onDone);
    }

    private onEditContaContabil(objeto: any) {
        this._contaContabilApiService.onPut(objeto, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseContaContabil = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma conta contábil encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._contaContabilApiService.onGetById(id, onDone);
    }

    private onGetFather(fatherId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                var fatherCode: string = this.contaContabilPaiObject.codigo,
                    nextCode: string = Response.toString();

                var newCode: any = this._contaContabilService.getLastCodeNumber(fatherCode, nextCode);

                this.formObject.codigo = newCode;
                this._utilService.setSelectOnFormControl(this.form, 'codigo', newCode);
                this.checkIfAnalytic();
            } else {
                console.log("Erro: " + Response.message);
            }
            this.loading = false;
        }.bind(this));

        this._contaContabilApiService.onGetFather(fatherId, onDone);
    }

    //check if exists the code typed by user
    private checkIfExistsCode(newCode: string) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                if (Response.length > 0) {
                    this.codeExists = true;
                } else {
                    this.codeExists = false;
                }

            } else {
                console.log("Erro: " + Response.message);
            }
            this.loading = false;
        }.bind(this));

        this._contaContabilApiService.onGetByCode(newCode, onDone);
    }

    //if de last digit of the code is no empty, de object is analytic
    private checkIfAnalytic() {
        var newCode: string = this.formObject.codigo;
        var codeSplit: string[] = newCode.split(".");
        var lastIndex: number = codeSplit.length - 1;
        var lastDigit: number = parseInt(codeSplit[lastIndex]);

        if (lastDigit > 0) {
            this.disabledModel = true;
            this.formObject.descricaoAnalitica = true;
        }

        this.checkModel();
    }

    private testSession() {
        var id: number;
        var session: any = this._contaContabilService.getSessionStorage();
        this._contaContabilService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.checkModel();
    }

    private setEditSession() {
    }

    private setNewSession() {
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(contasContabeisStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.descricao = newAutoComplete.descricao;
            this.formObject.tipoId = newAutoComplete.tipoId;
            this.formObject.descricaoAnalitica = newAutoComplete.descricaoAnalitica;

            this.setActionTitle(this.formObject.id);
            this.setModelToForm();
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {
        this.checkType();
        this.checkModel();

        if (this.formObject.pai) {
            this.contaContabilPaiObject = this.formObject.pai;
            delete this.formObject['pai'];

            var text: string = this._autocompleteService.getTextSelect2(this.contaContabilPaiObject, 'descricao');
            text = this.contaContabilPaiObject.codigo.concat(" - " + text);
            var selectObject:any = {text: text, id: this.contaContabilPaiObject.id};

            this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.contaContabilSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'pai', this.contaContabilPaiObject);
        }
    }

    private goToList() {
        this._contaContabilNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._contaContabilService.returnToOtherForm(this.otherForm, this.responseContaContabil);
        } else {
            this.goToList();
        }
    }

    private getTiposContaContabil() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.types = Response;
                this.checkType();
            }
        }.bind(this));

        this._contaContabilTipoService.onGetAll(onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil-form/conta-contabil-form.component.ts
 **/